import React from "react";
import Slider from "react-slick";
// import "@fortawesome/fontawesome-free/css/all.min.css";  
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../assets/Style.css"; // Your custom styles

const testimonials = [
    {
        name: "Dylan B.",
        text: "Code Buddy's built a site that matched our vision – responsive, professional, and easy to work with.",
    },
    {
        name: "Sarah K.",
        text: "Exceptional service from start to finish. They understood our needs perfectly and delivered beyond expectations.",
    },
    {
        name: "Michael T.",
        text: "The team was professional, responsive, and delivered our project ahead of schedule. Highly recommended!",
    },
    {
        name: "Jessica L.",
        text: "We've worked with many developers, but Code Buddy stands out for their attention to detail and creative solutions.",
    },
    {
        name: "Robert P.",
        text: "The website they built for us has significantly improved our online presence and customer engagement.",
    },
];

export default function Testimonial() {
    const settings = {
        dots: true,
        arrows: true,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 1024,
                settings: { slidesToShow: 2, dots: false },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    arrows: false,
                    dots: true,
                    centerMode: true,
                    centerPadding: "20px",
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    arrows: false,
                    dots: true,
                    centerMode: false,
                },
            },
        ],
    };

    return (
        <section className="testimonial">
            <div className="testimonial__header">
                <h3>What they say about us</h3>
                <p style={{ paddingTop: "10px" }}>
                    We're proud to work with clients across industries, helping them bring their
                    ideas to life through technology. Here's what some of them had to say
                </p>
            </div>

            <div className="testimonial__slider">
                <div className="testimonial__slider-container">
                    <Slider className="testimonial__cards" {...settings} >
                        {testimonials.map((item, index) => (
                            < div><div key={index} className="testimonial__card">
                                <h4 className="testimonial__name">{item.name}</h4>
                                <div className="testimonial__rating">
                                    {[...Array(5)].map((_, i) => (
                                        <i key={i} className="fas fa-star"></i>
                                    ))}
                                </div>
                                <p className="testimonial__text">{item.text}</p>
                            </div></div>


                        ))}
                    </Slider>

                    <div className="testimonial__footer">
                        <h4 style={{ color: "white" }}>We are all over the globe</h4>
                    </div>
                </div>
            </div>
        </section>
    );
}
